/**
 * Single-click signup for the membership product. No sizes, no quantity
 * choice — always adds exactly 1 of the membership variant.
 *
 * THE selling_plan FIELD IS REQUIRED. Without it Shopify creates a plain
 * one-off line item: charged once, no subscription contract, and every
 * Shopify Flow workflow keyed to "Subscription contract created" or
 * "billing attempt success" never fires — so the `Member` tag is never
 * applied and the member gate never opens. Orders #SMC1001 and #SMC1002
 * were both lost this way before this was fixed.
 *
 * Ticking "Only sell this product with these purchase options" on the
 * product does not save you here: that flag is enforced when Shopify
 * builds the cart through its own product form, and a direct
 * /cart/add.js POST with a bare variant ID goes straight past it.
 *
 * If the plan ID is missing from the markup, this refuses to add to cart
 * and sends the visitor to the product page instead, where Shopify
 * renders its own subscription picker. Selling the wrong thing quietly is
 * worse than an extra click.
 */
(function () {
  function init() {
    document.querySelectorAll('[data-membership-signup]').forEach(function (root) {
      var btn = root.querySelector('[data-membership-join]');
      var variantId = root.getAttribute('data-variant-id');
      var sellingPlanId = root.getAttribute('data-selling-plan-id');
      if (!btn || !variantId) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();

        if (!sellingPlanId) {
          // No subscription plan available — don't risk a one-off charge.
          console.error('Membership signup: no selling plan on the membership product.');
          window.location.href = '/products/custom-apparel-membership';
          return;
        }

        var originalLabel = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Joining…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: parseInt(variantId, 10),
              quantity: 1,
              selling_plan: parseInt(sellingPlanId, 10)
            }]
          })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (err) { throw err; });
            }
            return res.json();
          })
          .then(function (data) {
            // Confirm Shopify actually recorded the subscription. If it
            // didn't, the cart holds a one-off charge that would bill once
            // and never renew, so say so rather than pushing to checkout.
            var line = data && data.items ? data.items[0] : data;
            if (line && !line.selling_plan_allocation) {
              console.error('Membership signup: line added without a selling plan', line);
              btn.disabled = false;
              btn.textContent = originalLabel;
              alert('We could not start your monthly membership. Please use the product page.');
              return;
            }
            window.location.href = '/cart';
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = originalLabel;
            alert('Something went wrong. Please try again.');
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
